import { Link } from "react-router-dom";
import { Button } from "@/components/ui/button";

export const StatusDot = ({ color, title }) => <span className={`status-dot status-${color}`} title={title} data-testid={`status-dot-${color}`} />;

const BADGE = {
  draft: "bg-slate-500/20 text-slate-300", approved: "bg-blue-500/20 text-blue-300", sent: "bg-indigo-500/20 text-indigo-300",
  outstanding: "bg-amber-500/20 text-amber-300", paid: "bg-emerald-500/20 text-emerald-300", overdue: "bg-red-500/20 text-red-300",
  awaiting_signature: "bg-amber-500/20 text-amber-300", signed: "bg-emerald-500/20 text-emerald-300", active: "bg-emerald-500/20 text-emerald-300",
  Open: "bg-emerald-500/20 text-emerald-300", "On Hold": "bg-amber-500/20 text-amber-300", Closed: "bg-slate-500/20 text-slate-300",
  Verified: "bg-emerald-500/20 text-emerald-300", Pending: "bg-amber-500/20 text-amber-300", Rejected: "bg-red-500/20 text-red-300",
  New: "bg-blue-500/20 text-blue-300", Contacted: "bg-indigo-500/20 text-indigo-300", "Proposal Sent": "bg-amber-500/20 text-amber-300",
  Engaged: "bg-emerald-500/20 text-emerald-300", Lost: "bg-slate-500/20 text-slate-400",
  Upcoming: "bg-blue-500/20 text-blue-300", Filed: "bg-indigo-500/20 text-indigo-300", Completed: "bg-emerald-500/20 text-emerald-300", Adjourned: "bg-amber-500/20 text-amber-300",
  admin: "bg-[color-mix(in_srgb,var(--brand)_20%,transparent)] text-[var(--brand-hover)]", lawyer: "bg-blue-500/20 text-blue-300", support: "bg-slate-500/20 text-slate-300",
};
export const Pill = ({ value, testId }) => (
  <span data-testid={testId} className={`inline-flex items-center px-2.5 py-0.5 rounded-full text-[11px] font-semibold tracking-wide ${BADGE[value] || "bg-slate-500/20 text-slate-300"}`}>
    {(value || "").replace(/_/g, " ")}
  </span>
);

export const PageHeader = ({ eyebrow, title, subtitle, actions, testId }) => (
  <div className="flex flex-col md:flex-row md:items-end justify-between gap-4 mb-8 fade-in" data-testid={testId}>
    <div>
      {eyebrow && <p className="eyebrow mb-2">{eyebrow}</p>}
      <h1 className="text-3xl sm:text-4xl font-serif font-semibold text-white tracking-tight">{title}</h1>
      {subtitle && <p className="text-sm text-slate-400 mt-1">{subtitle}</p>}
    </div>
    {actions && <div className="flex items-center gap-3 flex-wrap">{actions}</div>}
  </div>
);

export const StatCard = ({ label, value, sub, testId, accent, icon: Icon, delay = 0, color = "var(--brand)" }) => {
  const c = accent === "red" ? "#F87171" : color;
  return (
    <div data-testid={testId} style={{ animationDelay: `${delay}ms`, borderLeft: `3px solid ${c}` }}
      className="panel panel-hover p-6 fade-in relative overflow-hidden">
      <div className="flex items-start justify-between">
        <p className="eyebrow">{label}</p>
        {Icon && <Icon className="w-5 h-5" style={{ color: c }} />}
      </div>
      <p className={`mt-3 text-4xl font-serif font-bold tracking-tight ${accent === "red" ? "text-red-300" : "text-white"}`}>{value}</p>
      {sub && <p className="text-xs text-slate-400 mt-1.5">{sub}</p>}
      <div className="absolute -bottom-6 -right-6 w-24 h-24 rounded-full" style={{ background: `${c}14` }} />
    </div>
  );
};

export const Empty = ({ text, testId }) => <div data-testid={testId} className="text-center text-slate-500 text-sm py-12">{text}</div>;

export const BackLink = ({ to, label }) => <Link to={to} className="text-xs text-slate-400 hover:text-[var(--brand)] transition-colors" data-testid="back-link">← {label}</Link>;

export const Section = ({ title, actions, children, testId, className = "", id }) => (
  <section id={id} className={`panel p-6 fade-in ${className}`} data-testid={testId}>
    <div className="flex items-center justify-between mb-4 gap-3 flex-wrap">
      <h3 className="font-serif text-xl text-white font-medium">{title}</h3>
      <div className="flex gap-2 flex-wrap">{actions}</div>
    </div>
    {children}
  </section>
);

export const GoldButton = (props) => <Button {...props} className={`btn-gold ${props.className || ""}`} />;
